import React from 'react';
import { Button } from 'semantic-ui-react';
import './styles.css';

const FailedMessage = () => (
  <div id="notfound">
    <div className="notfound">
      <h2>Oops! Pagina não encontrada</h2>
      <p>
        Desculpe, mas a página que você está procurando não foi encontrada, foi removida ou você não
        tem permissão para acessá-la.
      </p>
      <Button className="primary" onClick={() => this.props.history.push('/timer')}>
        Voltar a página Inicial
      </Button>
    </div>
  </div>
);

export default FailedMessage;
